
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralConeUp as ObiBeaconGeneralConeUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-cone-up.js';
 
 
 

 
 export const ObiBeaconGeneralConeUp = createComponent({
   react: React,
   tagName: 'obi-beacon-general-cone-up',
   elementClass: ObiBeaconGeneralConeUpElement,
   events: {
     
   }
  });
 
 